(function() {
  const header = document.querySelector("page-header, .wt-header");
  if (!header) return;

  // Store original colors when dropdown opens
  let originalColors = null;

  // Watch for dropdown-opened class changes on mega menu items
  const megaMenuItems = document.querySelectorAll(".wt-page-nav-mega__item--parent");
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        const target = mutation.target;
        const isDropdownOpen = target.classList.contains("dropdown-opened");
        
        if (isDropdownOpen) {
          handleDropdownOpen();
        } else {
          // Check if ANY dropdown is still open
          const anyOpen = document.querySelector(".wt-page-nav-mega__item--parent.dropdown-opened");
          if (!anyOpen) {
            handleDropdownClose();
          }
        }
      }
    });
  });

  megaMenuItems.forEach((item) => {
    observer.observe(item, { attributes: true });
  });

  function handleDropdownOpen() {
    // Get current header text color
    const currentColor = getComputedStyle(header).getPropertyValue("--color-header-text").trim() ||
                         getComputedStyle(header).getPropertyValue("--color-transparent-header").trim();
    
    // Check if current color is white/light
    if (isLightColor(currentColor)) {
      // Store original values if not already stored
      if (!originalColors) {
        originalColors = {
          transparentHeader: header.style.getPropertyValue("--color-transparent-header"),
          headerText: header.style.getPropertyValue("--color-header-text"),
          menuText: header.style.getPropertyValue("--color-menu-text"),
          storesNav: header.style.getPropertyValue("--color-stores-nav"),
          logoInvert: header.style.getPropertyValue("--logo-invert"),
          hadInvertClass: header.classList.contains("header--logo-inverted")
        };
      }
      
      // Set to black
      header.style.setProperty("--color-transparent-header", "#000000");
      header.style.setProperty("--color-header-text", "#000000");
      header.style.setProperty("--color-menu-text", "#000000");
      header.style.setProperty("--color-stores-nav", "#000000");
      header.style.setProperty("--logo-invert", "0");
      header.classList.remove("header--logo-inverted");
      header.classList.add("header--dropdown-override");
    }
  }

  function handleDropdownClose() {
    if (originalColors && header.classList.contains("header--dropdown-override")) {
      // Restore original colors
      if (originalColors.transparentHeader) {
        header.style.setProperty("--color-transparent-header", originalColors.transparentHeader);
      } else {
        header.style.removeProperty("--color-transparent-header");
      }
      
      if (originalColors.headerText) {
        header.style.setProperty("--color-header-text", originalColors.headerText);
      } else {
        header.style.removeProperty("--color-header-text");
      }
      
      if (originalColors.menuText) {
        header.style.setProperty("--color-menu-text", originalColors.menuText);
      } else {
        header.style.removeProperty("--color-menu-text");
      }
      
      if (originalColors.storesNav) {
        header.style.setProperty("--color-stores-nav", originalColors.storesNav);
      } else {
        header.style.removeProperty("--color-stores-nav");
      }
      
      if (originalColors.logoInvert) {
        header.style.setProperty("--logo-invert", originalColors.logoInvert);
      } else {
        header.style.removeProperty("--logo-invert");
      }
      
      if (originalColors.hadInvertClass) {
        header.classList.add("header--logo-inverted");
      }
      
      header.classList.remove("header--dropdown-override");
      originalColors = null;
    }
  }

  function isLightColor(color) {
    if (!color) return false;
    
    let r, g, b;
    
    if (color.startsWith("#")) {
      const hex = color.replace("#", "");
      if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
      } else {
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
      }
    } else if (color.startsWith("rgb")) {
      const match = color.match(/\d+/g);
      if (match) {
        r = parseInt(match[0]);
        g = parseInt(match[1]);
        b = parseInt(match[2]);
      }
    } else if (color === "white" || color === "#fff" || color === "#ffffff") {
      return true;
    } else if (color === "black" || color === "#000" || color === "#000000") {
      return false;
    }
    
    if (r !== undefined && g !== undefined && b !== undefined) {
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.5;
    }
    
    return false;
  }
})();